import { LeadCapture } from '../utils/types';
import { ZustandAPI } from './globalStore';

export type LeadCaptureStore = {
  leadCapture: LeadCapture;
  setLeadCapture: (leadCapture: LeadCapture) => void;
};

export const leadCaptureStore = (args: ZustandAPI): LeadCaptureStore => {
  const { get, set } = args;

  const setLeadCapture = (leadCapture: LeadCapture) => {
    set((state: LeadCaptureStore) => {
      state.leadCapture = leadCapture;
    });
  };

  const leadCapture = get()?.leadCapture;

  return {
    leadCapture: leadCapture,
    setLeadCapture,
  };
};
